import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Reusable empty-state placeholder for lists and tables.
 */
const EmptyState = ({
  title = "No data found",
  description = "",
  minHeight = 260,
  action = null,
}) => {
  return (
    <Box
      sx={{
        minHeight,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        px: 2,
        textAlign: "center",
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        {title}
      </Typography>
      {description ? (
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      ) : null}
      {action}
    </Box>
  );
};

export default EmptyState;
